module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_estado.7bae3f2f.svg";